import { render, staticRenderFns } from "./CardTaskItem.vue?vue&type=template&id=38af9811&scoped=true&"
import script from "./CardTaskItem.vue?vue&type=script&lang=js&"
export * from "./CardTaskItem.vue?vue&type=script&lang=js&"
import style0 from "./CardTaskItem.vue?vue&type=style&index=0&id=38af9811&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38af9811",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon,VRating,VRow,VTextField})
